import type {
  BaseQueryFn,
  EndpointBuilder,
  FetchArgs,
} from "@reduxjs/toolkit/query/react";

export type BuilderSeatDto = {
  userId: string;
  name: string;
  email: string;
  userCreditsUsed: number;
  sharedCreditsUsed: number;
};

export type ListBuilderSeatsResponse = {
  builders: BuilderSeatDto[];
  totalPurchasedSeats: number;
};

type ListBuilderSeatsApiResponse = {
  data: ListBuilderSeatsResponse;
};

type ReduxApiBuilder<ReducerPath extends string = string> = EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, unknown>,
  string,
  ReducerPath
>;

export function buildBuilderSeatsEndpoints<ReducerPath extends string>(
  builder: ReduxApiBuilder<ReducerPath>,
  builderSeatsTag: string,
) {
  return {
    listBuilderSeats: builder.query<ListBuilderSeatsResponse, void>({
      query: () => "v1/billing/builder-seats",
      transformResponse: (response: ListBuilderSeatsApiResponse) =>
        response.data,
      providesTags: [builderSeatsTag],
    }),
    assignBuilderSeat: builder.mutation<
      { success: boolean },
      { userId: string }
    >({
      query: ({ userId }) => ({
        url: "v1/billing/builder-seats",
        method: "POST",
        body: { userId },
      }),
      invalidatesTags: [builderSeatsTag],
    }),
    unassignBuilderSeat: builder.mutation<
      { success: boolean },
      { userId: string }
    >({
      query: ({ userId }) => ({
        url: `v1/billing/builder-seats/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: [builderSeatsTag],
    }),
  };
}
